import { useCallback, useEffect, useMemo } from 'react';
import { useRecoilSnapshot } from 'recoil';
import { legacy_createStore as createStore } from 'redux';
const getReduxDevTools = () => typeof window !== 'undefined' &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.__REDUX_DEVTOOLS_EXTENSION__;
export const useRecoilRedux = () => {
    const reducer = useCallback((state = {}, action) => {
        var _a;
        const { payload } = action;
        if ((_a = payload === null || payload === void 0 ? void 0 : payload.node) === null || _a === void 0 ? void 0 : _a.key) {
            return Object.assign(Object.assign({}, state), { [payload.node.key]: payload.loadable });
        }
        else {
            return state;
        }
    }, []);
    const reduxDevTools = getReduxDevTools();
    const store = useMemo(() => {
        if (!reduxDevTools) {
            return null;
        }
        return createStore(reducer, reduxDevTools({ name: 'recoil state observer', maxAge: 100 }));
    }, [reducer, reduxDevTools]);
    const snapshot = useRecoilSnapshot();
    useEffect(() => {
        if (!store) {
            return;
        }
    }, [store]);
    useEffect(() => {
        if (!store) {
            return;
        }
        for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
            const loadable = snapshot.getLoadable(node);
            const action = {
                type: `[state] ${node.key}`,
                payload: { node, loadable: loadable.contents },
            };
            store.dispatch(action);
        }
    }, [store, snapshot]);
    return null;
};
